import { headerState } from "../../share/layout/header/HeaderState"

class StorageService{
    deleteAllDataInStorage(){
        localStorage.clear();
        sessionStorage.clear();
    }
    // IMPORTANT DATA
    async setAccessToken(accessToken:string){
        sessionStorage.setItem('AccessToken', accessToken)
    }
    getAccessToken(){
        return sessionStorage.getItem('AccessToken')
    }
    async deleteAccessToken(){
        sessionStorage.removeItem('AccessToken')
    }
    async setRefreshToken(accessToken:string){
        localStorage.setItem('RefreshToken', accessToken)
    }
    getRefreshToken(){
        return localStorage.getItem('RefreshToken')
    }
    async deleteRefreshToken(){
        localStorage.removeItem('RefreshToken')
    }
    ///////////////////////////////////////
    //    MENU
    async setSelectedItemInMainMenu(itemValue:string){
        // Get the main menu element
        sessionStorage.setItem('SelectedItemInMainMenu', itemValue);
    }
    getSelectedItemInMainMenu(){
        // Get the main menu element
        return sessionStorage.getItem('SelectedItemInMainMenu')
    }
    async deleteSelectedItemInMainMenu(){
        sessionStorage.removeItem('SelectedItemInMainMenu');
    }

    ///////       ----SET MEAL TYPE----        ////////////
    async setMealType(itemValue:string){
        // Get the main menu element
        sessionStorage.setItem('MealType', itemValue);
    }
    getMealType(){
        // Get the main menu element
        return sessionStorage.getItem('MealType')
    }
    async deleteMealType(){
        // Get the main menu element
        sessionStorage.removeItem('MealType');
    }
    ///////////////////////////////////////
    async setDishInCart(dishData:any){
        // Set the Dish info
        localStorage.setItem('Dish', JSON.stringify(dishData));
        headerState.amount += 1;
    }
    getDishInCart(){
        // Get the Dish info
        return JSON.parse(localStorage.getItem('Dish')!);
    }
    async deleteDishInCart(){
        // Get the Dish info
        localStorage.removeItem('Dish');
        headerState.amount += 1;
    }
    getDishInCartAmount(){
        const dishList = this.getDishInCart();
        return (dishList ? dishList.length : '')
    }

}

export const storageService = new StorageService();